import * as React from 'react'
import classNames from 'classnames'
import { LucideIcon } from 'utils/lucideIcon'
import { useTranslation } from 'translations'

interface CapacitySearchProps {
    value: string
    onChange: (value: string) => void
    inputRef?: React.RefObject<HTMLInputElement>
    collapsed?: boolean
}

export function CapacitySearch({ value, onChange, inputRef, collapsed = false }: CapacitySearchProps) {
    const { t } = useTranslation()
    return (
        <div
            className={classNames('capacity-search', { 'is-filled': value !== '', 'is-collapsed': collapsed })}
            aria-hidden={collapsed}
        >
            <LucideIcon iconName="Search" size={16} className="capacity-search-icon" />
            <input
                type="text"
                className="capacity-search-input"
                ref={inputRef}
                placeholder={t('capacity.list.search')}
                aria-label={t('capacity.list.search')}
                autoComplete="off"
                value={value}
                disabled={collapsed}
                tabIndex={collapsed ? -1 : undefined}
                onChange={(event) => onChange(event.target.value)}
            />
        </div>
    )
}
